const constants = {
    ACTIONS : {
    GET_QUESTIONS_DATA_SUCCESS : 'GET_QUESTIONS_DATA_SUCCESS',
    GET_QUESTIONS_DATA_FAILED : 'GET_QUESTIONS_DATA_FAILED',
    POST_QUESTIONS_DATA_SUCCESS:'POST_QUESTIONS_DATA_SUCCESS',
    POST_QUESTIONS_DATA_FAILED : 'POST_QUESTIONS_DATA_FAILED',
    GET_USER_EXISTING_SUCCESS:'GET_USER_EXISTING_SUCCESS',
    GET_USER_EXISTING_FAILED:'GET_USER_EXISTING_FAILED'
    }
}
export default constants;  